import carlosPhoto from '../assets/img/author-carlos.jpg';
import nataliaPhoto from '../assets/img/author-natalia.jpg';

const AUTHORS = {
  carlos: {
    name: 'Carlos Alviz',
    role: 'Co-fundador, FinMaple',
    linkedin: 'https://www.linkedin.com/in/alvizcarlos/',
    photo: carlosPhoto,
  },
  natalia: {
    name: 'Natalia Duarte',
    role: 'Co-fundadora, FinMaple',
    linkedin: 'https://www.linkedin.com/in/natalia-duarteh/',
    photo: nataliaPhoto,
  },
};

const postsData = [
  {
    id: 3,
    title: 'Guía completa para enviar dinero a Latinoamérica desde Canadá',
    slug: 'enviar-dinero-latinoamerica-canada',
    path: '/blog/enviar-dinero-latinoamerica-canada',
    excerpt:
      'Comparamos las mejores opciones para enviar remesas: bancos, apps y servicios especializados. Aprende a evitar comisiones ocultas y obtener el mejor tipo de cambio.',
    date: '2026-02-10',
    image: '/images/blog/enviar-dinero-latinoamerica-remesas.jpg',
    tags: ['Remesas', 'Ahorro'],
    author: AUTHORS.carlos,
    readTime: 9,
    level: 'basico',
    idealFor: 'Recién llegados, Familias',
    content: `
<p>Para millones de latinoamericanos en Canadá, enviar dinero a casa no es opcional - es una responsabilidad y un acto de amor. Pero las comisiones y los tipos de cambio desfavorables pueden hacer que una parte significativa de tu esfuerzo se pierda en el camino. En esta guía te mostramos <strong>como maximizar cada dolar que envias</strong>.</p>

<h2>El costo real de una remesa</h2>
<p>Cuando envias dinero al exterior, pagas dos costos que no siempre son obvios:</p>
<ol>
  <li><strong>La comisión directa</strong>: La tarifa que el servicio te cobra por la transferencia (puede ser desde $0 hasta $25+ CAD)</li>
  <li><strong>El margen en el tipo de cambio</strong>: Este es el costo oculto. Muchos servicios te ofrecen un tipo de cambio inferior al real del mercado y se quedan con la diferencia. Esto puede representar entre un 1% y un 5% adicional</li>
</ol>
<p>Ejemplo real: Si envias $500 CAD a México, un servicio con "comisión de $0" pero un margen de cambio del 3% te esta cobrando efectivamente $15 CAD. Mientras que un servicio con comisión de $5 pero tipo de cambio del mercado real te sale más barato.</p>

<h2>Las mejores opciones comparadas (2026)</h2>

<h3>Wise (antes TransferWise)</h3>
<p><strong>Mejor para: transparencia y tipo de cambio real</strong></p>
<ul>
  <li>Usa el tipo de cambio medio del mercado (el "real")</li>
  <li>Comisión típica: 0.5% - 1.5% dependiendo del país</li>
  <li>Tiempo de entrega: 1-2 días habiles</li>
  <li>Disponible para la mayoría de países latinoamericanos</li>
  <li>App en español con interfaz clara que muestra exactamente cuánto recibe tu familia</li>
</ul>

<h3>Remitly</h3>
<p><strong>Mejor para: envios rápidos a México y Centroamérica</strong></p>
<ul>
  <li>Entrega en minutos con la opción Express</li>
  <li>Tu familia puede recoger el dinero en tiendas OXXO, Elektra o directamente en su cuenta bancaria</li>
  <li>Promociones frecuentes para nuevos usuarios (primer envió sin comisión)</li>
  <li>Atencion al cliente en español 24/7</li>
</ul>

<h3>Western Union</h3>
<p><strong>Mejor para: países con acceso bancario limitado</strong></p>
<ul>
  <li>La red de retiro de efectivo más grande del mundo</li>
  <li>Tu familia puede recoger el dinero en miles de puntos físicos</li>
  <li>Comisiones más altas que las opciones digitales</li>
  <li>Útil cuando el destinatario no tiene cuenta bancaria</li>
</ul>

<h3>Transferencia bancaria directa</h3>
<p><strong>Mejor para: montos grandes ($2,000+)</strong></p>
<ul>
  <li>Los bancos canadienses cobran entre $25-$50 CAD por transferencia internacional</li>
  <li>El tipo de cambio suele tener un margen del 2-3%</li>
  <li>Solo conviene para montos grandes donde la tarifa fija se diluye</li>
  <li>Puede tardar 3-5 días habiles</li>
</ul>

<h2>Comparación de costos: enviando $500 CAD a Colombia</h2>
<table>
  <thead>
    <tr><th>Servicio</th><th>Comisión</th><th>Tipo de cambio</th><th>Tu familia recibe</th></tr>
  </thead>
  <tbody>
    <tr><td>Wise</td><td>$4.50</td><td>Mercado real</td><td>~$1,545,000 COP</td></tr>
    <tr><td>Remitly</td><td>$3.99</td><td>-1.2% del mercado</td><td>~$1,520,000 COP</td></tr>
    <tr><td>Western Union</td><td>$12.00</td><td>-2.5% del mercado</td><td>~$1,475,000 COP</td></tr>
    <tr><td>Banco (TD/RBC)</td><td>$40.00</td><td>-3% del mercado</td><td>~$1,410,000 COP</td></tr>
  </tbody>
</table>
<p><em>Nota: Los montos son aproximados y varian según el día. Siempre verifica antes de enviar.</em></p>

<h2>Consejos para pagar menos</h2>
<ul>
  <li><strong>Compara siempre antes de enviar</strong>: Las tasas cambian diariamente. Usa herramientas como la calculadora de Wise o Remitly para ver quien ofrece más ese día</li>
  <li><strong>Envia montos más grandes con menos frecuencia</strong>: Si puedes, envia $1,000 una vez al mes en vez de $250 cada semana - te ahorras multiples comisiones</li>
  <li><strong>Paga desde tu cuenta bancaria</strong>: Usar tarjeta de crédito para enviar remesas agrega un cargo de "cash advance" del 3-5% adicional</li>
  <li><strong>Aprovecha las promociones para nuevos usuarios</strong>: Wise, Remitly y otros frecuentemente ofrecen el primer envió gratis o con comisión reducida</li>
  <li><strong>Evita los servicios de cambio en efectivo</strong>: Las casas de cambio físicas en Canadá suelen tener los peores tipos de cambio</li>
</ul>

<h2>Aspectos fiscales: tengo que declarar mis remesas?</h2>
<p>En Canadá, <strong>no pagas impuestos por enviar dinero al exterior</strong>. Sin embargo, hay dos cosas que debes saber:</p>
<ul>
  <li>Si envias más de <strong>$10,000 CAD en efectivo</strong> fuera de Canadá, debes declararlo en la frontera (esto aplica solo a efectivo físico)</li>
  <li>Las transferencias electrónicas internacionales mayores a $10,000 CAD son reportadas automáticamente al FINTRAC (Centro de Analisis de Operaciones y Reportes Financieros), pero esto es un proceso automático y no implica impuestos</li>
</ul>

<p><em>Cada dolar que ahorras en comisiones es un dolar más que llega a tu familia. Tomarte 5 minutos para comparar opciones antes de cada envió puede ahorrarte cientos de dólares al año.</em></p>

<h2>Fuentes oficiales</h2>
<ul class="sources-list">
  <li><a href="https://www.canada.ca/en/immigration-refugees-citizenship/services/new-immigrants/new-life-canada/financial.html" target="_blank" rel="noopener noreferrer">IRCC — Financial Information for Newcomers</a></li>
  <li><a href="https://www.canada.ca/en/financial-consumer-agency.html" target="_blank" rel="noopener noreferrer">Financial Consumer Agency of Canada</a></li>
</ul>
`,
  },
  {
    id: 5,
    title: '5 errores financieros que cometen los recién llegados a Canadá (y como evitarlos)',
    slug: 'errores-financieros-recien-llegados-canada',
    path: '/blog/errores-financieros-recien-llegados-canada',
    excerpt:
      'Desde no abrir una TFSA hasta enviar remesas por los canales más caros. Conoce los errores más comunes y las soluciones prácticas para cada uno.',
    date: '2026-01-28',
    image: '/images/blog/errores-financieros-recien-llegados.jpg',
    tags: ['Finanzas Personales', 'Recién Llegados'],
    author: AUTHORS.carlos,
    readTime: 8,
    level: 'basico',
    idealFor: 'Recién llegados',
    content: `
<p>Llegar a Canadá es emocionante pero también abrumador. Entre buscar trabajo, encontrar vivienda y adaptarte a un nuevo país, las decisiones financieras a veces quedan en segundo plano. El problema es que algunos errores cometidos en los primeros meses pueden costarte <strong>miles de dólares a largo plazo</strong>. Estos son los 5 más comunes que vemos en la comunidad latinoamericana - y como evitarlos.</p>

<h2>Error #1: No abrir una TFSA desde el día uno</h2>
<p><strong>El problema</strong>: Muchos recién llegados dejan su dinero en una cuenta de ahorro regular que paga entre 0.01% y 2% de interés - y ese interés es gravable. Mientras tanto, su espacio de contribución en la TFSA se desperdicia.</p>
<p><strong>La solución</strong>: Abre una TFSA en tu primer mes en Canadá. No necesitas ser experto en inversiones - incluso una TFSA con una cuenta de ahorro de alto interés (como EQ Bank al 4%+) te da ganancias completamente libres de impuestos. Cada año que no usas tu espacio TFSA es dinero que dejas sobre la mesa.</p>
<p><strong>Impacto real</strong>: Si ahorras $500/mes en una TFSA con 5% de retorno anual, en 10 años tendrás $77,000+. En una cuenta regular, el mismo ahorro te deja con aproximadamente $70,000 después de impuestos. Esos $7,000+ de diferencia son completamente gratis.</p>

<h2>Error #2: Pagar solo el mínimo de la tarjeta de crédito</h2>
<p><strong>El problema</strong>: Las tarjetas de crédito en Canadá cobran entre 19.99% y 22.99% de interés anual. Si solo pagas el mínimo ($10 o el 2% del saldo), una compra de $3,000 puede tardarte <strong>más de 30 años en pagar</strong> y terminarias pagando más de $7,000 en intereses.</p>
<p><strong>La solución</strong>: Trata tu tarjeta de crédito como una tarjeta de débito - solo gasta lo que puedes pagar completo al final del mes. Si ya tienes un saldo alto, considera una tarjeta de transferencia de saldo con 0% de interés introductorio (como la MBNA True Line) para pagarlo más rápido.</p>
<p><strong>Regla de oro</strong>: Si no puedes pagar el saldo completo, paga al menos 3 veces el pago mínimo. Esto reduce drásticamente los intereses y el tiempo de pago.</p>

<h2>Error #3: Enviar remesas por el canal más caro</h2>
<p><strong>El problema</strong>: Por costumbre o desconocimiento, muchos latinos usan Western Union o su banco para enviar dinero a casa. Estos suelen ser los canales más caros, con comisiones altas Y margenes desfavorables en el tipo de cambio.</p>
<p><strong>La solución</strong>: Usa servicios digitales como <strong>Wise</strong> o <strong>Remitly</strong> que ofrecen tipos de cambio cercanos al del mercado real y comisiones significativamente menores. La diferencia puede ser de $20-$50 por envió.</p>
<p><strong>Impacto real</strong>: Si envias $500 mensuales y ahorras $30 por envió al cambiar de servicio, eso son <strong>$360 al año</strong> que se quedan en tu bolsillo o llegan a tu familia.</p>

<h2>Error #4: No declarar impuestos (o hacerlo mal)</h2>
<p><strong>El problema</strong>: Algunos recién llegados no declaran impuestos porque piensan que "no les toca" o porque en su país el empleador se encargaba de todo. En Canadá, <strong>declarar impuestos es obligatorio si eres residente fiscal</strong>, incluso si no ganaste dinero durante el año.</p>
<p><strong>La solución</strong>: Declara tus impuestos cada año antes del 30 de abril. Aun si no debes nada, al declarar puedes recibir:</p>
<ul>
  <li><strong>GST/HST Credit</strong>: Hasta $519/ano para individuos con ingresos bajos</li>
  <li><strong>Canada Child Benefit (CCB)</strong>: Hasta $7,787/año por hijo menor de 6 años</li>
  <li><strong>Climate Action Incentive</strong>: Reembolso trimestral que varia por provincia</li>
  <li><strong>Otros creditos provinciales</strong>: Ontario Trillium Benefit, etc.</li>
</ul>
<p><strong>Impacto real</strong>: Una familia con dos hijos que no declara impuestos puede estar <strong>perdiendo más de $15,000 al año</strong> en beneficios gubernamentales.</p>

<h2>Error #5: No aprovechar los programas para newcomers de los bancos</h2>
<p><strong>El problema</strong>: Los cinco grandes bancos de Canadá (RBC, TD, Scotiabank, BMO, CIBC) ofrecen paquetes exclusivos para recién llegados con beneficios significativos. Pero muchos recién llegados abren una cuenta "regular" sin preguntar por estos programas porque no saben que existen.</p>
<p><strong>La solución</strong>: Antes de abrir cualquier cuenta, pregunta específicamente por el "newcomer package" o "new to Canadá program". Estos típicamente incluyen:</p>
<ul>
  <li>Cuenta chequera sin cuota mensual por 1-2 años (ahorro de $180-$360)</li>
  <li>Tarjeta de crédito sin historial crediticio canadiense</li>
  <li>Transferencias internacionales gratuitas</li>
  <li>Acceso a asesores financieros (algunos bancos tienen asesores bilingues)</li>
  <li>Caja de seguridad gratuita por un año</li>
  <li>Descuentos en servicios adicionales</li>
</ul>
<p><strong>Ventana de oportunidad</strong>: La mayoría de estos programas estan disponibles durante tus primeros <strong>2-3 años como residente permanente o con permiso de trabajo</strong>. Después de ese periodo, ya no calificas.</p>

<h2>Resumen: tu checklist financiero para los primeros 90 días</h2>
<ul>
  <li>Abre una cuenta bancaria con programa newcomer</li>
  <li>Solicita una tarjeta de crédito (secured o newcomer)</li>
  <li>Abre una TFSA y configura depositos automáticos</li>
  <li>Registrate en Wise o Remitly para remesas</li>
  <li>Solicita tu SIN (Social Insurance Number) para poder trabajar y declarar impuestos</li>
  <li>Anota la fecha límite de impuestos (30 de abril) y aplica para GST/HST credit</li>
  <li>Descarga Borrowell o Credit Karma para monitorear tu crédito</li>
</ul>

<p><em>Los primeros meses en Canadá son críticos para tu salud financiera a largo plazo. Evitar estos 5 errores puede significar la diferencia entre luchar con las finanzas durante años o construir una base sólida que te permita prosperar en tu nuevo hogar.</em></p>

<h2>Fuentes oficiales</h2>
<ul class="sources-list">
  <li><a href="https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/about-your-tax-return.html" target="_blank" rel="noopener noreferrer">CRA — About Your Tax Return</a></li>
  <li><a href="https://www.canada.ca/en/revenue-agency/services/e-services/digital-services-individuals/account-individuals.html" target="_blank" rel="noopener noreferrer">CRA My Account</a></li>
</ul>
`,
  },
  {
    id: 6,
    title: 'T4 explicado para recién llegados: como leer tu slip de empleo en Canadá',
    slug: 't4-explicado-inmigrantes-canada',
    path: '/blog/t4-explicado-espanol-impuestos-canada',
    excerpt:
      'Tu T4 es el documento más importante de la temporada de taxes. Te explicamos casilla por casilla que significa cada número y como usarlo para declarar tus impuestos correctamente.',
    date: '2026-02-21',
    image: '/images/blog/t4-formulario-impuestos-canada.jpg',
    tags: ['Impuestos', 'Temporada Fiscal 2026'],
    author: AUTHORS.carlos,
    readTime: 11,
    level: 'basico',
    idealFor: 'Recién llegados, Autónomos',
    content: `
<div style="border-left:4px solid #1E3A5F;background:#E8F5E9;padding:16px 20px;border-radius:0 8px 8px 0;margin-bottom:24px;">
  <p style="margin:0 0 4px;font-weight:700;color:#1E3A5F;font-size:0.85rem;">Respuesta rapida</p>
  <p style="margin:0;color:#37474F;font-size:1rem;line-height:1.6;">El <strong>T4</strong> (Statement of Remuneration Paid) es el slip que tu empleador te entrega antes del 28 de febrero de cada año. Resume cuánto ganaste y cuánto te descontaron en impuestos, CPP y EI durante el año fiscal anterior. Lo necesitas para hacer tu declaracion de impuestos ante el CRA.</p>
</div>

<p>Si es tu primera temporada de taxes en Canadá, el T4 puede parecer un documento lleno de números sin sentido. Pero en realidad es bastante simple una vez que entiendes las casillas clave. Esta guía te lleva paso a paso por cada una.</p>

<h2>¿Cómo leer un T4 - casillas clave</h2>
<p>Tu T4 tiene muchas casillas, pero estas son las que realmente importan para tu declaracion:</p>
<table>
  <thead>
    <tr><th>Casilla</th><th>Nombre</th><th>Que significa</th></tr>
  </thead>
  <tbody>
    <tr><td><strong>Box 14</strong></td><td>Employment income</td><td>Tu ingreso total de empleo antes de deducciones. Es el número mas grande y el mas importante - es lo que el CRA considera tu ingreso gravable de ese empleo.</td></tr>
    <tr><td><strong>Box 16</strong></td><td>CPP contributions</td><td>Lo que pagaste al Canada Pension Plan. Este dinero financia tu pension de jubilacion futura.</td></tr>
    <tr><td><strong>Box 18</strong></td><td>EI premiums</td><td>Tus contribuciones al Employment Insurance. Si pierdes tu trabajo, estos pagos te dan derecho a recibir EI.</td></tr>
    <tr><td><strong>Box 22</strong></td><td>Income tax deducted</td><td>El total de impuesto sobre la renta que tu empleador ya le pago al CRA de tu parte. Si pagaste de mas, recibes reembolso.</td></tr>
    <tr><td><strong>Box 24</strong></td><td>EI insurable earnings</td><td>El ingreso sobre el cual se calcularon tus contribuciones de EI. Generalmente igual o similar a Box 14.</td></tr>
    <tr><td><strong>Box 26</strong></td><td>CPP pensionable earnings</td><td>El ingreso sobre el cual se calcularon tus contribuciones al CPP.</td></tr>
    <tr><td><strong>Box 44</strong></td><td>Union dues</td><td>Si eres parte de un sindicato, este monto es deducible de impuestos.</td></tr>
    <tr><td><strong>Box 52</strong></td><td>Pension adjustment</td><td>Aparece si tu empleador tiene un plan de pension. Reduce tu espacio de contribucion al <a href="/financlopedia/rrsp-canada">RRSP</a>.</td></tr>
  </tbody>
</table>

<p>Tu empleador debe entregarte (o hacerte disponible en linea) tu T4 antes del <strong>28 de febrero</strong>. Si trabajaste para multiples empleadores durante el año, recibiras un T4 de cada uno - debes incluirlos todos en tu declaracion.</p>

<h2>Diferencia T4 vs RL-1 en Quebec</h2>
<p>Si vives en Quebec, el sistema fiscal es diferente al resto de Canadá. Ademas del T4 (federal), tu empleador te entrega un <strong>RL-1</strong> (Relevé 1), que es el equivalente provincial para <a href="/financlopedia/revenu-quebec-canada">Revenu Québec</a>.</p>
<table>
  <thead>
    <tr><th>Caracteristica</th><th>T4</th><th>RL-1</th></tr>
  </thead>
  <tbody>
    <tr><td>Emitido por</td><td>El empleador</td><td>El empleador</td></tr>
    <tr><td>Se usa para</td><td>Declaracion federal (T1) ante el <a href="/financlopedia/cra-canada">CRA</a></td><td>Declaracion provincial (TP-1) ante Revenu Québec</td></tr>
    <tr><td>Ingreso total</td><td>Box 14</td><td>Case A</td></tr>
    <tr><td>Impuesto deducido</td><td>Box 22 (federal)</td><td>Case E (provincial Quebec)</td></tr>
    <tr><td>QPP (en vez de CPP)</td><td>No aplica</td><td>Case B - Quebec Pension Plan</td></tr>
    <tr><td>QPIP (seguro parental)</td><td>No aplica</td><td>Case H - Quebec Parental Insurance</td></tr>
  </tbody>
</table>
<p><strong>Importante:</strong> En Quebec debes hacer <strong>dos declaraciones</strong> - la T1 para el CRA y la TP-1 para Revenu Québec. No basta con declarar solo a nivel federal. Muchos recién llegados a Montreal cometen este error y pierden beneficios provinciales como el <a href="credito-solidaridad-quebec-inmigrantes">Crédito de Solidaridad</a>.</p>

<h2>Preguntas frecuentes</h2>

<h3>No recibi mi T4. Que hago?</h3>
<p>Si tu empleador no te envió el T4 antes del 28 de febrero, contáctalo directamente. Si no responde, puedes llamar al CRA al <strong>1-800-959-8281</strong> después del 8 de marzo - ellos pueden darte la información de tus slips si el empleador ya los reportó electrónicamente. También puedes verificar en <strong>Mi Cuenta CRA</strong> (My Account), donde los T4 aparecen automáticamente a mediados de marzo.</p>

<h3>Tuve varios trabajos. Necesito todos los T4?</h3>
<p>Si. Debes declarar el ingreso de <strong>todos</strong> tus empleos durante el año. Si trabajaste en dos restaurantes y un almacen, necesitas tres T4. Cada T4 se suma al total de tu Box 14 en la declaracion.</p>

<h3>Recibi propinas o pago en efectivo que no aparece en el T4</h3>
<p>En Canadá, <strong>todo ingreso es gravable</strong>, incluyendo propinas y pagos en efectivo. Si recibes ingresos que no aparecen en un T4, debes declararlos en la linea 10400 (Other employment income) de tu T1. No declarar ingresos en efectivo es evasion fiscal y puede resultar en penalidades del <a href="/financlopedia/cra-canada">CRA</a>.</p>

<div style="border-left:4px solid #D32F2F;background:#FFF8E1;padding:16px 20px;border-radius:0 8px 8px 0;margin:32px 0;">
  <p style="margin:0 0 4px;font-weight:700;color:#D32F2F;font-size:0.95rem;">Preguntale a Maya</p>
  <p style="margin:0;color:#37474F;font-size:0.95rem;line-height:1.6;">Tienes dudas sobre tu T4 o como declarar tus impuestos? Usa el boton rojo de Maya (abajo a la derecha) para hacer preguntas en español sobre tu situacion fiscal.</p>
</div>

<h2>Herramientas gratuitas para declarar</h2>
<div style="display:flex;gap:16px;flex-wrap:wrap;margin:16px 0 24px;">
  <div style="flex:1;min-width:240px;border:1px solid #E0E0E0;border-radius:12px;padding:20px;background:#fff;">
    <p style="margin:0 0 4px;font-weight:700;color:#1A1A1A;font-size:1rem;">Wealthsimple Tax</p>
    <p style="margin:0 0 12px;color:#5F6B7A;font-size:0.9rem;line-height:1.5;">100% gratis. Interfaz simple, ideal para declaraciones de empleo estandar. Disponible en linea sin descargar nada.</p>
    <span style="display:inline-block;background:#1E3A5F;color:#fff;padding:6px 16px;border-radius:20px;font-size:0.85rem;font-weight:600;">Recomendado por FinMaple</span>
  </div>
  <div style="flex:1;min-width:240px;border:1px solid #E0E0E0;border-radius:12px;padding:20px;background:#fff;">
    <p style="margin:0 0 4px;font-weight:700;color:#1A1A1A;font-size:1rem;">TurboTax</p>
    <p style="margin:0 0 12px;color:#5F6B7A;font-size:0.9rem;line-height:1.5;">Version Free cubre situaciones simples (T4 + RRSP). Guia paso a paso con preguntas en ingles/frances.</p>
    <span style="display:inline-block;background:#F9A825;color:#1A1A1A;padding:6px 16px;border-radius:20px;font-size:0.85rem;font-weight:600;">Version gratuita disponible</span>
  </div>
</div>

<p>Recuerda que la fecha limite para declarar es el <strong>30 de abril de 2026</strong> (15 de junio si eres trabajador autonomo). Consulta nuestro <a href="../calendario-fiscal-2026">calendario fiscal 2026</a> para todas las fechas importantes.</p>

<p>Si vives en Quebec, no te pierdas nuestra guia sobre el <a href="credito-solidaridad-quebec-inmigrantes">Crédito de Solidaridad</a> - un beneficio que muchos latinos no reclaman y que puede significar hasta $1,200 al año.</p>

<h2>Fuentes oficiales</h2>
<ul class="sources-list">
  <li><a href="https://www.canada.ca/en/financial-consumer-agency/services/credit-cards.html" target="_blank" rel="noopener noreferrer">Financial Consumer Agency — Credit Cards</a></li>
  <li><a href="https://www.canada.ca/en/financial-consumer-agency/services/credit-reports-score/build-credit-history.html" target="_blank" rel="noopener noreferrer">Building a Credit History in Canada</a></li>
</ul>
`,
  },
  {
    id: 7,
    title: 'Crédito de Solidaridad de Quebec: el beneficio que muchos latinos no reclaman',
    slug: 'credito-solidaridad-quebec-inmigrantes',
    path: '/blog/credito-solidaridad-quebec-inmigrantes',
    excerpt:
      'Si vives en Quebec y pagas renta, probablemente calificas para un pago mensual del gobierno provincial. Aprende como solicitarlo y evita los errores mas comunes.',
    date: '2026-02-21',
    image: '/images/blog/solidarity-tax-credit-quebec.jpg',
    tags: ['Impuestos', 'Quebec', 'Temporada Fiscal 2026'],
    author: AUTHORS.natalia,
    readTime: 10,
    level: 'intermedio',
    idealFor: 'Familias',
    content: `
<div style="border-left:4px solid #1E3A5F;background:#E8F5E9;padding:16px 20px;border-radius:0 8px 8px 0;margin-bottom:24px;">
  <p style="margin:0 0 4px;font-weight:700;color:#1E3A5F;font-size:0.85rem;">Respuesta rapida</p>
  <p style="margin:0;color:#37474F;font-size:1rem;line-height:1.6;">El <strong>Crédito de Solidaridad</strong> (crédit d'impôt pour solidarité) es un pago mensual no gravable de <a href="/financlopedia/revenu-quebec-canada">Revenu Québec</a> para residentes de bajos y medianos ingresos. Combina tres componentes: TVQ, vivienda y regiones nordicas. Puede significar hasta <strong>$1,200 o mas al año</strong> depositados directamente en tu cuenta.</p>
</div>

<p>Si eres latino recién llegado viviendo en Quebec - ya sea en Montreal, Québec City, Gatineau o cualquier otra ciudad - este beneficio fue diseñado pensando en personas exactamente como tu: trabajadores con ingresos bajos o medianos que pagan renta.</p>

<p style="background:#FFF8E1;padding:14px 18px;border-radius:8px;font-size:0.95rem;color:#37474F;line-height:1.6;"><strong>Muchos latinos en Montreal pierden este dinero</strong> simplemente porque no saben que existe o porque no completan el Anexo D en su declaracion provincial. No seas uno de ellos - es dinero que te corresponde y que puede ayudarte a cubrir tus gastos basicos.</p>

<h2>Cuanto dinero recibiré?</h2>
<p>El monto depende de tu ingreso, situacion familiar y si vives en una region nordica. Estos son los montos maximos para el periodo de pago julio 2026 - junio 2027 (basados en la declaracion fiscal 2025):</p>
<table>
  <thead>
    <tr><th>Componente</th><th>Persona sola</th><th>Pareja / Familia</th></tr>
  </thead>
  <tbody>
    <tr><td><strong>Componente TVQ</strong></td><td>$340/año</td><td>$340 + $148 por conyuge</td></tr>
    <tr><td><strong>Componente vivienda</strong></td><td>$721/año</td><td>$721/año</td></tr>
    <tr><td><strong>Componente regiones nordicas</strong></td><td>$0 - $2,106/año</td><td>Segun zona</td></tr>
    <tr><td style="font-weight:700;color:#1E3A5F;">Total maximo (sin norte)</td><td style="font-weight:700;color:#1E3A5F;">~$1,061/año</td><td style="font-weight:700;color:#1E3A5F;">~$1,209/año</td></tr>
  </tbody>
</table>
<p><em>Los montos se pagan mensualmente via depósito directo. Los montos exactos se ajustan anualmente por Revenu Québec según la inflacion.</em></p>
<p>El credito se reduce gradualmente a medida que tu ingreso sube. Generalmente, si tu ingreso neto individual supera los ~$38,000 pierdes el componente de vivienda, y si supera ~$55,000 pierdes todo el credito. Para familias, los umbrales son mas altos.</p>

<h2>Requisitos criticos</h2>
<p>Para recibir el Crédito de Solidaridad debes cumplir <strong>todos</strong> estos requisitos:</p>

<h3>1. Residencia en Quebec el 31 de diciembre</h3>
<p>Debes haber sido residente de Quebec el 31 de diciembre del año fiscal. Si llegaste a Montreal en junio de 2025, calificas para la declaracion de 2025 (que haces en abril de 2026).</p>

<h3>2. Tener 18 años o mas</h3>
<p>O ser menor emancipado, o tener un conyuge, o ser padre/madre.</p>

<h3>3. Presentar la declaracion TP-1 (impuestos provinciales)</h3>
<p>Debes hacer tu declaracion provincial ante Revenu Québec. Recuerda: en Quebec hay <strong>dos declaraciones</strong> - la T1 (federal, ante el <a href="/financlopedia/cra-canada">CRA</a>) y la TP-1 (provincial). El Crédito de Solidaridad se solicita en la declaracion provincial.</p>

<h3>4. Completar el Anexo D (Schedule D)</h3>
<p>Este es el formulario específico donde solicitas el credito. <strong>Si no completas el Anexo D, no recibes el pago aunque califiques.</strong> Es el error mas común. En Wealthsimple Tax y TurboTax, el Anexo D se completa automáticamente si respondes las preguntas sobre tu vivienda.</p>

<h3>5. Obtener el RL-31 de tu propietario</h3>
<p>El <strong>RL-31</strong> (Relevé 31) es un recibo que tu landlord/propietario debe entregarte antes del 28 de febrero. Confirma cuánto pagaste de renta durante el año. Si tu propietario no te lo da, puedes solicitarlo formalmente y, si no coopera, contactar a Revenu Québec.</p>

<h3>6. Configurar depósito directo con Revenu Québec</h3>
<p>El Crédito de Solidaridad SOLO se paga por depósito directo. Si no configuras tu cuenta bancaria con Revenu Québec, no recibiras el pago. Puedes hacerlo en linea a traves de <strong>Mon dossier</strong> (tu cuenta en Revenu Québec) o al completar tu declaracion TP-1.</p>

<h2>Errores comunes que debes evitar</h2>

<h3>No pedir el RL-31 a tu propietario</h3>
<p>Muchos recién llegados no saben que el propietario esta <strong>obligado por ley</strong> a entregarte el RL-31. Si no lo recibes antes del 28 de febrero, enviala una solicitud por escrito. Si aun asi no coopera, puedes llamar a Revenu Québec y ellos intervienen. Sin el RL-31, pierdes el componente de vivienda ($721/año).</p>

<h3>No configurar depósito directo con Revenu Québec</h3>
<p>Atencion: configurar depósito directo con el CRA (federal) <strong>NO</strong> es lo mismo que hacerlo con Revenu Québec (provincial). Son dos sistemas separados. Debes configurar ambos. Muchos recién llegados solo configuran el federal y se preguntan por que no reciben el Crédito de Solidaridad.</p>

<h3>No completar el Anexo D</h3>
<p>Repetimos porque es el error mas costoso: aunque hagas tu declaracion TP-1, si no llenas el Anexo D especificamente, Revenu Québec no te otorga el credito. Es como no pedirlo.</p>

<h3>Solo hacer la declaracion federal</h3>
<p>Si solo declaras ante el CRA (T1) y no ante Revenu Québec (TP-1), pierdes <strong>todos</strong> los beneficios provinciales: Crédito de Solidaridad, credito por impuesto de Quebec, y otros. En Quebec las dos declaraciones son obligatorias.</p>

<h3>No actualizar tu direccion</h3>
<p>Si te mudaste durante el año, asegurate de que tanto el CRA como Revenu Québec tengan tu direccion actualizada. Esto afecta especialmente al componente de vivienda del Crédito de Solidaridad.</p>

<div style="border-left:4px solid #D32F2F;background:#FFF8E1;padding:16px 20px;border-radius:0 8px 8px 0;margin:32px 0;">
  <p style="margin:0 0 4px;font-weight:700;color:#D32F2F;font-size:0.95rem;">Preguntale a Maya</p>
  <p style="margin:0;color:#37474F;font-size:0.95rem;line-height:1.6;">Tienes dudas sobre el Crédito de Solidaridad, el RL-31 o como declarar en Quebec? Usa el boton rojo de Maya (abajo a la derecha) y pregunta en español.</p>
</div>

<h2>¿Cómo solicitarlo paso a paso</h2>
<ol>
  <li><strong>Pide tu RL-31</strong> a tu propietario (antes del 28 de febrero)</li>
  <li><strong>Reune tus documentos</strong>: T4, RL-1, RL-31, y cualquier otro slip de ingreso</li>
  <li><strong>Declara tus impuestos provinciales</strong> (TP-1) usando Wealthsimple Tax o TurboTax - ambos manejan Quebec</li>
  <li><strong>Completa el Anexo D</strong> cuando el software te pregunte sobre tu vivienda y renta</li>
  <li><strong>Configura depósito directo</strong> con Revenu Québec en Mon dossier</li>
  <li><strong>Envia tu declaracion</strong> antes del 30 de abril</li>
</ol>

<p>Si todo esta en orden, comenzaras a recibir los pagos mensuales a partir de <strong>julio de 2026</strong>.</p>

<p>Asegúrate también de entender tu <a href="t4-explicado-espanol-impuestos-canada">T4 y RL-1</a> antes de declarar - nuestra guia te explica cada casilla. Y si recién llegas a Canadá, visita nuestra seccion de <a href="../empieza-aqui">primeros pasos</a> para una guia completa de tu primer año financiero.</p>

<p>Consulta todas las fechas importantes en nuestro <a href="../calendario-fiscal-2026">calendario fiscal 2026</a>.</p>

<h2>Fuentes oficiales</h2>
<ul class="sources-list">
  <li><a href="https://www.canada.ca/en/revenue-agency/services/child-family-benefits/gsthstc.html" target="_blank" rel="noopener noreferrer">CRA — GST/HST Credit</a></li>
  <li><a href="https://www.canada.ca/en/revenue-agency/services/child-family-benefits/canada-child-benefit-overview.html" target="_blank" rel="noopener noreferrer">CRA — Canada Child Benefit</a></li>
</ul>
`,
  },
  {
    id: 8,
    title: 'Cómo construir tu crédito en Canadá desde cero',
    slug: 'construir-credito-canada-desde-cero',
    path: '/blog/construir-credito-canada-desde-cero',
    excerpt:
      'Llegaste a Canadá sin historial crediticio? Aprende paso a paso cómo construir tu crédito desde cero con tarjetas aseguradas, programas para newcomers y un plan de 90 días.',
    date: '2026-02-24',
    image: '/images/blog/construir-credito-canada-tarjeta.jpg',
    tags: ['Crédito', 'Recién Llegados'],
    author: AUTHORS.carlos,
    readTime: 10,
    level: 'basico',
    idealFor: 'Recién llegados',
    content: '',
  },
  {
    id: 9,
    title: 'Tarjetas para newcomers: qué piden los bancos',
    slug: 'tarjetas-newcomers-que-piden-bancos',
    path: '/blog/tarjetas-newcomers-que-piden-bancos',
    excerpt:
      'Guía completa en español sobre los documentos, requisitos y programas que los bancos canadienses exigen para aprobar tarjetas de crédito a recién llegados.',
    date: '2026-02-24',
    image: '/images/blog/tarjetas-credito-newcomers-canada.jpg',
    tags: ['Tarjetas de Crédito', 'Recién Llegados'],
    author: AUTHORS.carlos,
    readTime: 10,
    level: 'basico',
    idealFor: 'Recién llegados',
    content: '',
  },
  {
    id: 10,
    title: 'Mejores cuentas bancarias sin fees para recién llegados a Canadá',
    slug: 'mejores-cuentas-sin-fees-recien-llegados',
    path: '/blog/mejores-cuentas-sin-fees-recien-llegados',
    excerpt:
      'Guía completa de las mejores cuentas bancarias sin comisiones para recién llegados a Canadá. Bancos digitales, paquetes newcomer y cuentas low-cost comparados.',
    date: '2026-02-24',
    image: '/images/blog/cuentas-bancarias-sin-fees-canada.jpg',
    tags: ['Banca', 'Recién Llegados'],
    author: AUTHORS.carlos,
    readTime: 12,
    level: 'basico',
    idealFor: 'Recién llegados',
    content: '',
  },
  {
    id: 11,
    title: 'TFSA vs RRSP vs FHSA: cuál abrir primero como recién llegado',
    slug: 'tfsa-vs-rrsp-vs-fhsa-inmigrantes',
    path: '/blog/tfsa-vs-rrsp-vs-fhsa-inmigrantes',
    excerpt:
      'Conoce las diferencias entre TFSA, RRSP y FHSA, cómo funcionan para recién llegados a Canadá y cuál te conviene abrir primero según tu situación financiera.',
    date: '2026-02-24',
    image: '/images/blog/tfsa-rrsp-fhsa-comparacion-ahorro.jpg',
    tags: ['Ahorro', 'Impuestos', 'Cuentas Registradas'],
    author: AUTHORS.natalia,
    readTime: 12,
    level: 'intermedio',
    idealFor: 'Recién llegados, Familias',
    content: '',
  },
  {
    id: 12,
    title: 'Cómo elegir tu primera hipoteca en Canadá',
    slug: 'primera-hipoteca-canada-guia',
    path: '/blog/primera-hipoteca-canada-guia',
    excerpt:
      'Todo lo que necesitas saber para comprar tu primera casa en Canadá: down payment, stress test, seguro CMHC, costos de cierre y documentos necesarios.',
    date: '2026-02-24',
    image: '/images/blog/primera-hipoteca-canada-llaves.jpg',
    tags: ['Hipotecas', 'Recién Llegados'],
    author: AUTHORS.natalia,
    readTime: 14,
    level: 'avanzado',
    idealFor: 'Recién llegados, Familias',
    content: '',
  },
  {
    id: 13,
    title: 'Costo de vida en Montreal 2026: ¿Cuánto dinero necesitas al mes?',
    slug: 'costo-de-vida-montreal-2026',
    path: '/blog/costo-de-vida-montreal-2026',
    excerpt:
      'Descubre cuánto dinero necesitas realmente para vivir en Montreal en 2026. Desglose de gastos reales, salario recomendado y comparativa con Toronto.',
    date: '2026-03-02',
    image: '/images/blog/costo-vida-montreal-2026.jpg',
    tags: ['Costo de Vida', 'Montreal', 'Quebec', 'Recién Llegados'],
    author: AUTHORS.carlos,
    readTime: 12,
    level: 'basico',
    idealFor: 'Recién llegados, Familias',
    content: '',
  },
];

export default postsData;
